import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const zSensorForm = z.object({
  description: z
    .string()
    .max(500, {
      message: 'La description doit comporter au maximum 500 caractères.',
    })
    .optional(),
  fridgeId: z.number('Le réfrigérateur est requis.'),
  label: z
    .string()
    .nonempty({ message: 'Le libellé est requis.' })
    .max(100, { message: 'Le libellé doit comporter au maximum 100 caractères.' }),
  model: z
    .string()
    .nonempty({ message: 'Le modèle est requis.' })
    .max(100, { message: 'Le modèle doit comporter au maximum 100 caractères.' }),
  reference: z.string().nonempty({ message: 'La référence du capteur est requise.' }).max(50, {
    message: 'La référence du capteur doit comporter au maximum 50 caractères.',
  }),
})

export type SensorForm = z.infer<typeof zSensorForm>

// Form hook
export const useSensorForm = (defaultValues?: Partial<SensorForm>) => {
  const form = useForm<SensorForm>({
    // Validation function
    defaultValues: {
      reference: '',
      label: '',
      description: '',
      model: '',
      fridgeId: undefined,
      ...defaultValues,
    },
    resolver: zodResolver(zSensorForm),
  })

  return form
}
